// NOOS Ordering Dashboard (63_Noos.jsx), 2026-10-27. NOOS, Semi-NOOS, EOL, On-Demand, SAP, MOQ, CV are terms and stay as they are.
const en = {
  nav: "Supply Planning",
  title: "Supply Planning",
  tab_dashboard: "NOOS Replenishment",
  tab_tiers: "Tier list",
  tab_supply: "Supply parameters",
  tab_settings: "Settings",
  stockDay: "Stock as at",
  allEntities: "All entities",
  refresh: "Refresh",
  loading: "Loading…",
  colEntity: "Entity",
  colBelow: "Below",
  colExcess: "Excess",
  search: "Search SAP, product or colour…",
  shown: "{{n}} of {{total}}",
  clear: "Clear sort & filters",
  colProduct: "Product",
  colColor: "Colour",
  colTier: "Tier",
  colTarget: "Target wks",
  tierSub: "Miley's NOOS tier list, one row per SAP code (imported from the sheet's INPUT_03 on 27/Oct). A blank target uses the tier's default in Settings.",
  addTier: "Add a SAP code",
  edit: "Edit",
  save: "Save",
  cancel: "Cancel",
  active: "Active",
  owner: "Owner",
  action: "Action",
  default: "default",
  needCv: "need CV",
  supplySub: "Linda's product-level supply parameters (imported from the sheet's INPUT_05 on 27/Oct). Shown for reference — the reorder point uses the flat production lead time plus transit weeks.",
  scope: "Scope",
  ltWith: "LT with frame stock (wks)",
  ltNo: "LT no frame stock (wks)",
  cycle: "Order cycle (wks)",
  lifecycle: "Lifecycle",
  settingsSub: "Provisional business assumptions from the sheet, until the owners confirm them. Changes apply to the dashboard at once.",
  setTargetNoos: "NOOS coverage target (weeks)",
  setTargetSemi: "Semi-NOOS coverage target (weeks)",
  setZNoos: "Service level z — NOOS",
  setZSemi: "Service level z — Semi-NOOS",
  setExcess: "Excess threshold (weeks)",
  setProdLt: "Production lead time (weeks)",
  setTransit: "Transit weeks by entity (added to production lead time)",
  saved: "Saved.",
  // the Dashboard tab — the web app's words (Index.html); the Korean is Young's own, verbatim
  resetAssumptions: "Reset assumptions",
  fAll: "All",
  fNone: "None",
  fCore: "Core",
  refreshed: "Data refreshed",
  stockDayShort: "stock as at {{day}} ({{week}})",
  selloutWeeks: "Sell-out weeks: last 4W {{a}} → {{b}} · 52W {{c}} → {{d}}",
  noEntities: "No entities",
  nEntities: "{{n}} entities",
  allTiers: "All tiers",
  noTiers: "No tiers",
  nTiers: "{{n}} tiers",
  p1: "1. Coverage Assumptions",
  p2: "2. ROP Assumptions",
  p3: "3. Excess Assumption",
  aNoosTarget: "NOOS target coverage weeks (weeks)",
  aSemiTarget: "Semi-NOOS target coverage weeks (weeks)",
  aProdLt: "Production lead time (weeks)",
  aNoosZ: "NOOS service z (ratio)",
  aSemiZ: "Semi-NOOS service z (ratio)",
  aExcess: "Excess threshold weeks (weeks)",
  hNoosTarget: "Provisional - pending approval. Used for the below-coverage count; the default comes from Settings.",
  hSemiTarget: "Provisional - pending approval. Used for Semi-NOOS tier.",
  hProdLt: "Each entity's transit weeks are added: {{tr}}. Every portal row has its entity, so this takes the place of the web app's fallback lead time.",
  hNoosZ: "Provisional default z value: 2.33, roughly 99% service level.",
  hSemiZ: "Provisional default z value: 1.64, roughly 95% service level.",
  hExcess: "Provisional default is 15 weeks. Still a business threshold to confirm.",
  formula: "Formula: Coverage = On Hand / Last 4W Avg Sell-out. Safety Stock = z * normalized CV * avg weekly demand * sqrt(replenishment lead time). ROP = avg weekly demand * replenishment lead time + Safety Stock.",
  kBelow: "Coverage below target",
  kBelowN: "NOOS/Semi rows under target",
  rowsWord: "rows",
  kRop: "ROP alerts",
  kRopN: "Supply position at or below ROP",
  kExcess: "Excess SKUs",
  kExcessN: "Coverage above threshold",
  kReview: "Need review",
  kReviewN: "No CV, no tier match, no sell-out, net returns or no supply parameter",
  sOverview: "Overview",
  sBelow: "Below Coverage",
  sRop: "ROP Alerts",
  sExcess: "Excess",
  sReview: "Review Data",
  oEntity: "Coverage Weeks By Entity",
  oTier: "Count By Tier",
  hdBelow: "Count Of NOOS And Semi-NOOS Below Coverage",
  hdRop: "Reorder Point Alerts",
  hdExcess: "SKUs Sitting In Excess",
  hdReview: "Data To Check",
  colNo: "No",
  colRows: "Rows",
  colMedian: "Median cover (weeks)",
  colNeedCv: "Need CV",
  colSkuProduct: "SKU / Product",
  colOnHandPcs: "On Hand (pcs)",
  colAvgPcs: "Avg Sell-out (pcs/wk)",
  colCoverageWks: "Coverage (weeks)",
  colTargetWks: "Target (weeks)",
  colSignal: "Signal",
  colOpenPcs: "Open/In-transit (pcs)",
  colSupplyPcs: "Supply Position (pcs)",
  colRopPcs: "ROP (pcs)",
  colGapPcs: "Gap (pcs)",
  colLt: "LT (weeks)",
  colOver: "Over (weeks)",
  colIssue: "Issue",
  colNote: "Note",
  sigBelow: "Below target",
  sigReorder: "Reorder",
  sigExcess: "Excess",
  isCv: "Need CV",
  noteCv: "Need normalized CV to calculate ROP",
  isTier: "Tier match",
  noteTier: "No tier match — add the SAP code to the Tier list",
  isDead: "No sale 52W",
  noteDead: "No sell-out in the last 52 weeks - exclude from auto-replenishment",
  isSlow: "Slow mover",
  noteSlow: "Sold within 52 weeks but nothing in the last 4 weeks",
  isSupply: "No supply parameter",
  noteSupply: "No product-level MOQ / supply parameter match — ask Linda",
  noRows: "No rows under current assumptions.",
  foot: "Provisional assumptions: NOOS target {{a}} wks, Semi target {{b}} wks, production lead time {{c}} wks (+ transit), NOOS z {{d}}, Semi z {{e}}, excess threshold {{f}} wks.",
  capped: "Showing the first {{cap}} of {{n}} rows — filter to narrow.",
  srcTitle: "Data sources",
  srcStock: "Stock on hand",
  srcSales: "Sell-out up to",
  srcTransit: "Open PO (not yet received)",
  srcFile: "file",
  srcCarry: "file of {{day}} ({{name}}) — no newer file",
  srcNoStock: "not loaded for this day",
  srcNoSales: "no sales in 52 weeks",
  srcTransitN: "{{n}} items · {{q}} pcs",
  srcNoTransit: "not read — no source for this company's POs yet",
  isReturns: "Net returns",
  noteReturns: "More returned than sold (52 weeks or last 4 weeks) — customer returns, not a data error",
  srcNoneOpen: "none open on this day",
  srcTransitOnly: "shipped goods only: {{n}} items · {{q}} pcs (no open PO reading for this day)",
  srcNoteNoOp: "No open PO reading for this day — NetSuite can only be read for today, so an older day shows the goods already shipped. Red = older than the stock day or the sell-out window.",
  srcOpFailed: "(Reading NetSuite failed: {{why}})",
  srcNoTransitHinc: "not read yet — HINC's POs are in SAP",
  srcSumStock: "Stock {{day}}",
  srcSumSales: "Sell-out to {{day}}",
  srcSumOp: "Open PO read {{at}} UTC",
  srcSumNoOp: "No open PO reading for this day",
  srcSumWarn: "older data: {{list}}",
  srcDetails: "Details",
  srcHide: "Hide",
  srcColFrom: "Read from",
  srcColCome: "To come (pcs)",
  srcColGroup: "of it from group cos.",
  srcColPassed: "Passed on to group cos.",
  srcColPast: "Past due — not counted",
  srcColTo: "Transfer orders",
  srcLines: "{{n}} lines",
  srcNoteShort: "To come = PO lines not yet received and due on or after the stock day; a line past its expected date is taken as shipped (open only for payment). Goods a group company bought from another count for the buyer and come off the seller. Red = older than the stock day or the sell-out window.",
  setWeeks: "weeks",
  setCardTarget: "Coverage target",
  setTargetHint: "A row is \"below target\" when its coverage (on hand ÷ last-4-week average sell-out) is under this.",
  setCardZ: "Service level (z)",
  setZHint: "2.33 ≈ 99% · 1.64 ≈ 95% · 1.28 ≈ 90% service level. Used in the safety stock.",
  setCardLt: "Lead time & excess",
  setProdLtShort: "Production lead time",
  setExcessShort: "Excess threshold",
  setLtHint: "Reorder lead time = production lead time + the entity's transit weeks. Coverage above the excess threshold counts as excess.",
  setReadOnly: "Read-only — an admin changes these.",
  shareLink: "Get link",
  shareTitle: "Share the dashboard as a link",
  shareSub: "The dashboard as one HTML page, always the latest stock day, at the saved assumptions — opens without a portal sign-in.",
  shareWarn: "Anyone holding the link sees the stock, sell-out and open PO quantities (no prices). Replace it to stop the old one working, or switch it off.",
  noLink: "No link yet.",
  makeLink: "Make a link",
  replaceLink: "Replace the link",
  switchOff: "Switch the link off",
  copy: "Copy",
  copied: "Copied",
  open: "Open",
  close: "Close",
  setSave: "Save changes",
  setDiscard: "Discard",
  setDirty: "Unsaved changes",
  setClean: "All values saved. Changes apply to the dashboard at once.",
  savedAt: "Saved · {{n}} value(s) changed · {{at}}",
  setHistory: "History",
  setNoHistory: "No change recorded yet — each Save that changes a value is listed here.",
  histWhen: "When (VN time)",
  histWho: "Who",
  histField: "Setting",
  histWas: "Before",
  histNow: "After",
  setTransitShort: "Transit weeks",
};
const ko = {
  nav: "공급 계획",
  title: "공급 계획",
  tab_dashboard: "NOOS 재고 보충",
  tab_tiers: "티어 목록",
  tab_supply: "공급 파라미터",
  tab_settings: "설정",
  stockDay: "재고 기준일",
  allEntities: "전체 법인",
  refresh: "새로고침",
  loading: "불러오는 중…",
  colEntity: "법인",
  colBelow: "목표 미달",
  colExcess: "과잉 재고",
  search: "SAP, 제품, 색상 검색…",
  shown: "{{total}}개 중 {{n}}개",
  clear: "정렬·필터 초기화",
  colProduct: "제품",
  colColor: "색상",
  colTier: "재고 등급",
  colTarget: "목표(주)",
  tierSub: "Miley의 NOOS 티어 목록 (SAP 코드별, 10/27 시트 INPUT_03에서 가져옴). 목표가 비어 있으면 설정의 티어 기본값을 사용합니다.",
  addTier: "SAP 코드 추가",
  edit: "수정",
  save: "저장",
  cancel: "취소",
  active: "사용",
  owner: "담당",
  action: "작업",
  default: "기본값",
  needCv: "CV 필요",
  supplySub: "Linda의 제품별 공급 파라미터 (10/27 시트 INPUT_05에서 가져옴). 참고용이며, 재주문점은 고정 생산 리드타임 + 운송 주를 사용합니다.",
  scope: "범위",
  ltWith: "리드타임(프레임 재고 있음, 주)",
  ltNo: "리드타임(프레임 재고 없음, 주)",
  cycle: "발주 주기(주)",
  lifecycle: "라이프사이클",
  settingsSub: "담당자가 확정할 때까지 사용하는 임시 기준값입니다. 변경하면 대시보드에 바로 반영됩니다.",
  setTargetNoos: "NOOS 커버리지 목표(주)",
  setTargetSemi: "Semi-NOOS 커버리지 목표(주)",
  setZNoos: "서비스 수준 z — NOOS",
  setZSemi: "서비스 수준 z — Semi-NOOS",
  setExcess: "과잉 기준(주)",
  setProdLt: "생산 리드타임(주)",
  setTransit: "법인별 운송 주 (생산 리드타임에 더함)",
  saved: "저장했습니다.",
  resetAssumptions: "가정값 초기화",
  fAll: "전체",
  fNone: "없음",
  fCore: "핵심",
  refreshed: "데이터 갱신 시각",
  stockDayShort: "재고 기준일 {{day}} ({{week}})",
  selloutWeeks: "실판매 주차: 최근 4주 {{a}} → {{b}} · 52주 {{c}} → {{d}}",
  noEntities: "선택된 법인 없음",
  nEntities: "{{n}}개 법인",
  allTiers: "전체 재고 등급",
  noTiers: "선택된 재고 등급 없음",
  nTiers: "{{n}}개 재고 등급",
  p1: "1. 재고 소진 주수 가정값 (임시)",
  p2: "2. 리오더 시점 가정값 (임시)",
  p3: "3. 과잉 재고 가정값 (임시)",
  aNoosTarget: "NOOS 목표 주수 (주)",
  aSemiTarget: "Semi-NOOS 목표 주수 (주)",
  aProdLt: "생산 조달 기간 (주)",
  aNoosZ: "NOOS 서비스 수준 계수",
  aSemiZ: "Semi-NOOS 서비스 수준 계수",
  aExcess: "과잉 판정 기준 (주)",
  hNoosTarget: "임시값 - 미확정. 목표 미달 계산에 사용되며 기본값은 Settings 기준입니다.",
  hSemiTarget: "임시값 - 미확정. Semi-NOOS 재고 등급에 사용됩니다.",
  hProdLt: "법인별 운송 주수를 더합니다: {{tr}}. 포털에서는 모든 행에 법인이 있어 기본 조달기간 대신 이 값을 사용합니다.",
  hNoosZ: "임시 기본값: 2.33, 약 99% 서비스 수준입니다.",
  hSemiZ: "임시 기본값: 1.64, 약 95% 서비스 수준입니다.",
  hExcess: "임시 기본값은 15주입니다. 비즈니스 기준 확인이 필요합니다.",
  formula: "공식: 재고 소진 주수 = 현재고 / 최근 4주 평균 실판매. 안전재고 = 서비스 수준 계수 * 수요 변동성 * 평균 주간 수요 * sqrt(조달 기간). 리오더 시점 = 평균 주간 수요 * 조달 기간 + 안전재고.",
  kBelow: "목표 미달",
  kBelowN: "목표 미달 NOOS/Semi 행",
  rowsWord: "행",
  kRop: "리오더 필요",
  kRopN: "확보 수량이 리오더 시점 이하",
  kExcess: "과잉 재고 SKU",
  kExcessN: "과잉 판정 기준 초과",
  kReview: "검토 필요",
  kReviewN: "수요 변동성, 재고 등급, 실판매, 순반품 또는 supply parameter 확인 필요",
  sOverview: "Overview",
  sBelow: "Below Coverage",
  sRop: "ROP Alerts",
  sExcess: "Excess",
  sReview: "Review Data",
  oEntity: "법인별 재고 소진 주수",
  oTier: "재고 등급별 Count",
  hdBelow: "NOOS 및 Semi-NOOS 목표 미달 Count",
  hdRop: "리오더 필요",
  hdExcess: "과잉 재고 SKU",
  hdReview: "확인 필요 데이터",
  colNo: "No",
  colRows: "행",
  colMedian: "재고 소진 주수 중앙값 (주)",
  colNeedCv: "수요 변동성 필요",
  colSkuProduct: "SKU / Product",
  colOnHandPcs: "현재고 (pcs)",
  colAvgPcs: "평균 실판매 (주당 개수)",
  colCoverageWks: "재고 소진 주수 (주)",
  colTargetWks: "목표 주수 (주)",
  colSignal: "Signal",
  colOpenPcs: "발주분·운송중 (pcs)",
  colSupplyPcs: "확보 수량 (pcs)",
  colRopPcs: "리오더 시점 (pcs)",
  colGapPcs: "부족 수량 (pcs)",
  colLt: "조달 기간 (주)",
  colOver: "초과 주수 (주)",
  colIssue: "Issue",
  colNote: "Note",
  sigBelow: "목표 미만",
  sigReorder: "재주문",
  sigExcess: "과잉 재고",
  isCv: "수요 변동성 필요",
  noteCv: "ROP 계산을 위해 normalized CV 필요",
  isTier: "Tier match",
  noteTier: "재고 등급 match 없음 — Tier list에 SAP code 추가 필요",
  isDead: "52주간 판매 없음",
  noteDead: "최근 52주간 sell-out 없음 - 자동 발주 제외",
  isSlow: "판매 부진",
  noteSlow: "52주 내 판매 있으나 최근 4주 판매 없음",
  isSupply: "Supply parameter 없음",
  noteSupply: "제품별 MOQ / supply parameter match 없음 — Linda 확인 필요",
  noRows: "현재 가정 조건에 해당하는 행이 없습니다.",
  foot: "임시 가정값: NOOS 목표 {{a}}주, Semi 목표 {{b}}주, 생산 조달 기간 {{c}}주 (+운송), NOOS 서비스 수준 계수 {{d}}, Semi 서비스 수준 계수 {{e}}, 과잉 기준 {{f}}주.",
  capped: "{{n}}행 중 처음 {{cap}}행만 표시 — 필터로 좁혀 주세요.",
  srcTitle: "데이터 출처",
  srcStock: "현재고",
  srcSales: "실판매 기준일",
  srcTransit: "미입고 발주",
  srcFile: "파일",
  srcCarry: "{{day}} 파일 ({{name}}) — 최신 파일 없음",
  srcNoStock: "해당일 미적재",
  srcNoSales: "52주간 판매 없음",
  srcTransitN: "{{n}}개 품목 · {{q}} pcs",
  srcNoTransit: "조회 안 됨 — 이 법인의 발주 출처가 아직 없음",
  isReturns: "순반품",
  noteReturns: "판매보다 반품이 많음 (52주 또는 최근 4주) — 고객 반품이며 데이터 오류 아님",
  srcNoneOpen: "해당일 진행 중인 발주 없음",
  srcTransitOnly: "선적분만: {{n}}개 품목 · {{q}} pcs (해당일 미입고 발주 조회 없음)",
  srcNoteNoOp: "해당일 미입고 발주 조회가 없습니다 — NetSuite는 오늘 기준으로만 조회되므로 이전 날짜는 선적분만 표시합니다. 빨간색 = 재고 기준일 또는 실판매 기간보다 오래된 데이터.",
  srcOpFailed: "(NetSuite 조회 실패: {{why}})",
  srcNoTransitHinc: "아직 조회 안 됨 — HINC 발주는 SAP에 있음",
  srcSumStock: "재고 {{day}}",
  srcSumSales: "실판매 {{day}}까지",
  srcSumOp: "미입고 발주 {{at}} UTC 조회",
  srcSumNoOp: "해당일 미입고 발주 조회 없음",
  srcSumWarn: "이전 데이터: {{list}}",
  srcDetails: "자세히",
  srcHide: "접기",
  srcColFrom: "출처",
  srcColCome: "입고 예정 (pcs)",
  srcColGroup: "그중 그룹사 구매",
  srcColPassed: "그룹사로 넘어갈 수량",
  srcColPast: "예정일 경과 — 제외",
  srcColTo: "이동 오더",
  srcLines: "{{n}}행",
  srcNoteShort: "입고 예정 = 아직 입고되지 않았고 예정일이 재고 기준일 이후인 발주 행; 예정일이 지난 행은 선적 완료로 봅니다(대금 미결로만 열린 상태). 그룹사가 다른 그룹사에서 산 물량은 구매사에 반영하고 판매사에서 뺍니다. 빨간색 = 재고 기준일 또는 실판매 기간보다 오래된 데이터.",
  setWeeks: "주",
  setCardTarget: "목표 재고 소진 주수",
  setTargetHint: "재고 소진 주수(현재고 ÷ 최근 4주 평균 실판매)가 이 값보다 작으면 \"목표 미달\"입니다.",
  setCardZ: "서비스 수준 계수 (z)",
  setZHint: "2.33 ≈ 99% · 1.64 ≈ 95% · 1.28 ≈ 90% 서비스 수준. 안전재고 계산에 사용됩니다.",
  setCardLt: "리드타임 및 과잉 기준",
  setProdLtShort: "생산 리드타임",
  setExcessShort: "과잉 판정 기준",
  setLtHint: "리오더 리드타임 = 생산 리드타임 + 법인별 운송 주수. 재고 소진 주수가 과잉 판정 기준을 넘으면 과잉 재고입니다.",
  setReadOnly: "읽기 전용 — 관리자가 변경합니다.",
  shareLink: "링크 받기",
  shareTitle: "대시보드 링크 공유",
  shareSub: "저장된 가정값 기준, 항상 최신 재고 기준일의 대시보드 HTML 페이지 — 포털 로그인 없이 열립니다.",
  shareWarn: "링크를 가진 사람은 누구나 재고, 실판매, 미입고 발주 수량을 볼 수 있습니다(가격 없음). 기존 링크를 막으려면 교체하거나 끄세요.",
  noLink: "아직 링크가 없습니다.",
  makeLink: "링크 만들기",
  replaceLink: "링크 교체",
  switchOff: "링크 끄기",
  copy: "복사",
  copied: "복사됨",
  open: "열기",
  close: "닫기",
  setSave: "변경 저장",
  setDiscard: "되돌리기",
  setDirty: "저장되지 않은 변경 사항",
  setClean: "모든 값이 저장되어 있습니다. 변경 시 대시보드에 바로 반영됩니다.",
  savedAt: "저장됨 · {{n}}개 값 변경 · {{at}}",
  setHistory: "변경 이력",
  setNoHistory: "아직 변경 기록이 없습니다 — 값을 바꾼 저장마다 여기에 기록됩니다.",
  histWhen: "일시 (VN)",
  histWho: "변경자",
  histField: "항목",
  histWas: "이전",
  histNow: "이후",
  setTransitShort: "운송 주수",
};
const vi = {
  nav: "Kế hoạch cung ứng",
  title: "Kế hoạch cung ứng",
  tab_dashboard: "Bổ sung hàng NOOS",
  tab_tiers: "Danh sách tier",
  tab_supply: "Thông số cung ứng",
  tab_settings: "Cài đặt",
  stockDay: "Tồn kho ngày",
  allEntities: "Tất cả entity",
  refresh: "Làm mới",
  loading: "Đang tải…",
  colEntity: "Entity",
  colBelow: "Dưới mục tiêu",
  colExcess: "Tồn dư",
  search: "Tìm SAP, sản phẩm hoặc màu…",
  shown: "{{n}} / {{total}}",
  clear: "Bỏ sắp xếp & lọc",
  colProduct: "Sản phẩm",
  colColor: "Màu",
  colTier: "Tier",
  colTarget: "Mục tiêu (tuần)",
  tierSub: "Danh sách tier NOOS của Miley, mỗi dòng một mã SAP (nhập từ tab INPUT_03 của sheet ngày 27/10). Để trống mục tiêu thì dùng mặc định của tier trong Cài đặt.",
  addTier: "Thêm mã SAP",
  edit: "Sửa",
  save: "Lưu",
  cancel: "Huỷ",
  active: "Đang dùng",
  owner: "Người phụ trách",
  action: "Thao tác",
  default: "mặc định",
  needCv: "thiếu CV",
  supplySub: "Thông số cung ứng theo sản phẩm của Linda (nhập từ tab INPUT_05 ngày 27/10). Chỉ để tham khảo — điểm đặt hàng dùng lead time sản xuất cố định cộng tuần vận chuyển.",
  scope: "Phạm vi",
  ltWith: "Lead time có sẵn frame (tuần)",
  ltNo: "Lead time không có frame (tuần)",
  cycle: "Chu kỳ đặt hàng (tuần)",
  lifecycle: "Vòng đời",
  settingsSub: "Các giả định tạm thời lấy từ sheet, dùng tới khi người phụ trách xác nhận. Sửa là áp dụng ngay cho bảng tổng quan.",
  setTargetNoos: "Mục tiêu NOOS (tuần)",
  setTargetSemi: "Mục tiêu Semi-NOOS (tuần)",
  setZNoos: "Hệ số z — NOOS",
  setZSemi: "Hệ số z — Semi-NOOS",
  setExcess: "Ngưỡng tồn dư (tuần)",
  setProdLt: "Lead time sản xuất (tuần)",
  setTransit: "Tuần vận chuyển theo entity (cộng vào lead time sản xuất)",
  saved: "Đã lưu.",
  resetAssumptions: "Đặt lại giả định",
  fAll: "Tất cả",
  fNone: "Bỏ hết",
  fCore: "Core",
  refreshed: "Dữ liệu cập nhật lúc",
  stockDayShort: "tồn kho ngày {{day}} ({{week}})",
  selloutWeeks: "Tuần sell-out: 4 tuần gần nhất {{a}} → {{b}} · 52 tuần {{c}} → {{d}}",
  noEntities: "Chưa chọn entity",
  nEntities: "{{n}} entity",
  allTiers: "Tất cả tier",
  noTiers: "Chưa chọn tier",
  nTiers: "{{n}} tier",
  p1: "1. Giả định coverage",
  p2: "2. Giả định ROP",
  p3: "3. Giả định tồn dư",
  aNoosTarget: "Số tuần coverage mục tiêu NOOS (tuần)",
  aSemiTarget: "Số tuần coverage mục tiêu Semi-NOOS (tuần)",
  aProdLt: "Lead time sản xuất (tuần)",
  aNoosZ: "Hệ số z dịch vụ NOOS",
  aSemiZ: "Hệ số z dịch vụ Semi-NOOS",
  aExcess: "Ngưỡng tồn dư (tuần)",
  hNoosTarget: "Tạm thời - chờ duyệt. Dùng để đếm dòng dưới mục tiêu; mặc định lấy từ Settings.",
  hSemiTarget: "Tạm thời - chờ duyệt. Dùng cho tier Semi-NOOS.",
  hProdLt: "Cộng thêm số tuần vận chuyển của từng entity: {{tr}}. Trên portal dòng nào cũng có entity, nên ô này thay cho lead time mặc định của web app.",
  hNoosZ: "Giá trị z mặc định tạm thời: 2.33, khoảng 99% mức phục vụ.",
  hSemiZ: "Giá trị z mặc định tạm thời: 1.64, khoảng 95% mức phục vụ.",
  hExcess: "Mặc định tạm thời là 15 tuần. Ngưỡng này vẫn cần bên kinh doanh xác nhận.",
  formula: "Công thức: Coverage = Tồn kho / Sell-out trung bình 4 tuần. Safety Stock = z * normalized CV * nhu cầu trung bình/tuần * sqrt(lead time bổ sung hàng). ROP = nhu cầu trung bình/tuần * lead time bổ sung hàng + Safety Stock.",
  kBelow: "Coverage dưới mục tiêu",
  kBelowN: "Dòng NOOS/Semi dưới mục tiêu",
  rowsWord: "dòng",
  kRop: "Cảnh báo ROP",
  kRopN: "Supply position ≤ ROP",
  kExcess: "SKU tồn dư",
  kExcessN: "Coverage vượt ngưỡng",
  kReview: "Cần xem lại",
  kReviewN: "Thiếu CV, chưa khớp tier, không có sell-out, hàng trả về hoặc thiếu supply parameter",
  sOverview: "Tổng quan",
  sBelow: "Dưới mục tiêu",
  sRop: "Cảnh báo ROP",
  sExcess: "Tồn dư",
  sReview: "Dữ liệu cần xem",
  oEntity: "Số tuần coverage theo entity",
  oTier: "Số lượng theo tier",
  hdBelow: "NOOS và Semi-NOOS dưới mục tiêu",
  hdRop: "Cảnh báo điểm đặt hàng lại",
  hdExcess: "SKU đang tồn dư",
  hdReview: "Dữ liệu cần kiểm tra",
  colNo: "STT",
  colRows: "Dòng",
  colMedian: "Coverage trung vị (tuần)",
  colNeedCv: "Cần CV",
  colSkuProduct: "SKU / Sản phẩm",
  colOnHandPcs: "Tồn kho (pcs)",
  colAvgPcs: "Sell-out TB (pcs/tuần)",
  colCoverageWks: "Coverage (tuần)",
  colTargetWks: "Mục tiêu (tuần)",
  colSignal: "Tín hiệu",
  colOpenPcs: "Open PO / đang về (pcs)",
  colSupplyPcs: "Supply position (pcs)",
  colRopPcs: "ROP (pcs)",
  colGapPcs: "Thiếu (pcs)",
  colLt: "LT (tuần)",
  colOver: "Vượt (tuần)",
  colIssue: "Vấn đề",
  colNote: "Ghi chú",
  sigBelow: "Dưới mục tiêu",
  sigReorder: "Đặt lại hàng",
  sigExcess: "Tồn dư",
  isCv: "Cần CV",
  noteCv: "Cần normalized CV để tính ROP",
  isTier: "Chưa khớp tier",
  noteTier: "Chưa khớp tier — thêm SAP code vào Tier list",
  isDead: "Không bán 52 tuần",
  noteDead: "Không có sell-out trong 52 tuần gần nhất - loại khỏi bổ sung hàng tự động",
  isSlow: "Bán chậm",
  noteSlow: "Có bán trong 52 tuần nhưng 4 tuần gần nhất không bán",
  isSupply: "Thiếu supply parameter",
  noteSupply: "Chưa có MOQ / supply parameter theo sản phẩm — hỏi Linda",
  noRows: "Không có dòng nào với giả định hiện tại.",
  foot: "Giả định tạm thời: mục tiêu NOOS {{a}} tuần, Semi {{b}} tuần, lead time sản xuất {{c}} tuần (+ vận chuyển), z NOOS {{d}}, z Semi {{e}}, ngưỡng tồn dư {{f}} tuần.",
  capped: "Đang hiện {{cap}} dòng đầu trong {{n}} — lọc để thu hẹp.",
  srcTitle: "Nguồn dữ liệu",
  srcStock: "Tồn kho",
  srcSales: "Sell-out tới ngày",
  srcTransit: "PO chưa nhận",
  srcFile: "file",
  srcCarry: "file ngày {{day}} ({{name}}) — chưa có file mới hơn",
  srcNoStock: "chưa có cho ngày này",
  srcNoSales: "không có bán trong 52 tuần",
  srcTransitN: "{{n}} mã · {{q}} pcs",
  srcNoTransit: "chưa đọc — chưa có nguồn PO của công ty này",
  isReturns: "Hàng trả về",
  noteReturns: "Trả về nhiều hơn bán (52 tuần hoặc 4 tuần gần nhất) — hàng khách trả, không phải lỗi dữ liệu",
  srcNoneOpen: "ngày này không có PO đang mở",
  srcTransitOnly: "chỉ hàng đã giao lên đường: {{n}} mã · {{q}} pcs (ngày này chưa đọc PO mở)",
  srcNoteNoOp: "Ngày này chưa có lần đọc PO chưa nhận — NetSuite chỉ đọc được cho hôm nay, nên ngày cũ chỉ hiện hàng đã giao lên đường. Màu đỏ = cũ hơn ngày tồn kho hoặc khoảng sell-out.",
  srcOpFailed: "(Đọc NetSuite lỗi: {{why}})",
  srcNoTransitHinc: "chưa đọc — PO của HINC nằm ở SAP",
  srcSumStock: "Tồn kho {{day}}",
  srcSumSales: "Sell-out đến {{day}}",
  srcSumOp: "PO chưa nhận đọc lúc {{at}} UTC",
  srcSumNoOp: "Ngày này chưa đọc PO chưa nhận",
  srcSumWarn: "dữ liệu cũ: {{list}}",
  srcDetails: "Chi tiết",
  srcHide: "Ẩn",
  srcColFrom: "Nguồn",
  srcColCome: "Sắp về (pcs)",
  srcColGroup: "trong đó mua của tập đoàn",
  srcColPassed: "Chuyển tiếp cho tập đoàn",
  srcColPast: "Quá hạn — không tính",
  srcColTo: "Lệnh chuyển kho",
  srcLines: "{{n}} dòng",
  srcNoteShort: "Sắp về = dòng PO chưa nhận và có ngày dự kiến từ ngày tồn kho trở đi; dòng đã quá ngày dự kiến được xem như đã giao (chỉ còn mở vì chưa thanh toán). Hàng một công ty mua của công ty khác trong tập đoàn tính cho bên mua và trừ khỏi bên bán. Màu đỏ = cũ hơn ngày tồn kho hoặc khoảng sell-out.",
  setWeeks: "tuần",
  setCardTarget: "Mục tiêu coverage",
  setTargetHint: "Một dòng \"dưới mục tiêu\" khi coverage (tồn kho ÷ sell-out TB 4 tuần) thấp hơn số này.",
  setCardZ: "Mức phục vụ (z)",
  setZHint: "2.33 ≈ 99% · 1.64 ≈ 95% · 1.28 ≈ 90% mức phục vụ. Dùng để tính safety stock.",
  setCardLt: "Lead time & ngưỡng tồn dư",
  setProdLtShort: "Lead time sản xuất",
  setExcessShort: "Ngưỡng tồn dư",
  setLtHint: "Lead time đặt hàng = lead time sản xuất + số tuần vận chuyển của entity. Coverage vượt ngưỡng tồn dư thì tính là tồn dư.",
  setReadOnly: "Chỉ xem — admin mới đổi được.",
  shareLink: "Lấy link",
  shareTitle: "Chia sẻ dashboard bằng link",
  shareSub: "Dashboard dạng một trang HTML, luôn là ngày tồn kho mới nhất, theo giả định đã lưu — mở được mà không cần đăng nhập portal.",
  shareWarn: "Ai có link cũng xem được số tồn kho, sell-out và PO chưa nhận (không có giá). Thay link để link cũ hết hiệu lực, hoặc tắt hẳn.",
  noLink: "Chưa có link.",
  makeLink: "Tạo link",
  replaceLink: "Thay link",
  switchOff: "Tắt link",
  copy: "Sao chép",
  copied: "Đã sao chép",
  open: "Mở",
  close: "Đóng",
  setSave: "Lưu thay đổi",
  setDiscard: "Bỏ thay đổi",
  setDirty: "Có thay đổi chưa lưu",
  setClean: "Mọi giá trị đã được lưu. Thay đổi áp dụng ngay cho dashboard.",
  savedAt: "Đã lưu · {{n}} giá trị thay đổi · {{at}}",
  setHistory: "Lịch sử thay đổi",
  setNoHistory: "Chưa có thay đổi nào — mỗi lần Lưu có đổi giá trị sẽ được ghi ở đây.",
  histWhen: "Thời gian (giờ VN)",
  histWho: "Người đổi",
  histField: "Thiết lập",
  histWas: "Trước",
  histNow: "Sau",
  setTransitShort: "Tuần vận chuyển",
};
const zh = {
  nav: "供应计划",
  title: "供应计划",
  tab_dashboard: "NOOS 补货",
  tab_tiers: "等级列表",
  tab_supply: "供应参数",
  tab_settings: "设置",
  stockDay: "库存日期",
  allEntities: "全部法人",
  refresh: "刷新",
  loading: "加载中…",
  colEntity: "法人",
  colBelow: "低于目标",
  colExcess: "过量",
  search: "搜索 SAP、产品或颜色…",
  shown: "{{n}} / {{total}}",
  clear: "清除排序和筛选",
  colProduct: "产品",
  colColor: "颜色",
  colTier: "等级",
  colTarget: "目标周数",
  tierSub: "Miley 的 NOOS 等级列表，每个 SAP 代码一行（10/27 从表格 INPUT_03 导入）。目标为空时使用设置中的等级默认值。",
  addTier: "添加 SAP 代码",
  edit: "编辑",
  save: "保存",
  cancel: "取消",
  active: "启用",
  owner: "负责人",
  action: "操作",
  default: "默认",
  needCv: "缺 CV",
  supplySub: "Linda 的产品级供应参数（10/27 从表格 INPUT_05 导入）。仅供参考——再订货点使用固定生产交期加运输周数。",
  scope: "范围",
  ltWith: "有框架库存交期（周）",
  ltNo: "无框架库存交期（周）",
  cycle: "订货周期（周）",
  lifecycle: "生命周期",
  settingsSub: "在负责人确认之前使用的临时业务假设。修改后立即作用于看板。",
  setTargetNoos: "NOOS 覆盖目标（周）",
  setTargetSemi: "Semi-NOOS 覆盖目标（周）",
  setZNoos: "服务水平 z — NOOS",
  setZSemi: "服务水平 z — Semi-NOOS",
  setExcess: "过量阈值（周）",
  setProdLt: "生产交期（周）",
  setTransit: "各法人运输周数（加在生产交期上）",
  saved: "已保存。",
  resetAssumptions: "重置假设",
  fAll: "全部",
  fNone: "清空",
  fCore: "核心",
  refreshed: "数据刷新时间",
  stockDayShort: "库存日期 {{day}}（{{week}}）",
  selloutWeeks: "实销周次：最近 4 周 {{a}} → {{b}} · 52 周 {{c}} → {{d}}",
  noEntities: "未选择法人",
  nEntities: "{{n}} 个法人",
  allTiers: "全部等级",
  noTiers: "未选择等级",
  nTiers: "{{n}} 个等级",
  p1: "1. 覆盖周数假设",
  p2: "2. ROP 假设",
  p3: "3. 过剩库存假设",
  aNoosTarget: "NOOS 目标覆盖周数（周）",
  aSemiTarget: "Semi-NOOS 目标覆盖周数（周）",
  aProdLt: "生产交期（周）",
  aNoosZ: "NOOS 服务水平系数 z",
  aSemiZ: "Semi-NOOS 服务水平系数 z",
  aExcess: "过剩判定阈值（周）",
  hNoosTarget: "临时值 - 待确认。用于统计低于目标的行；默认值来自 Settings。",
  hSemiTarget: "临时值 - 待确认。用于 Semi-NOOS 等级。",
  hProdLt: "另加各法人的运输周数：{{tr}}。门户中每一行都有法人，因此用它代替网页版的默认交期。",
  hNoosZ: "临时默认 z 值：2.33，约 99% 服务水平。",
  hSemiZ: "临时默认 z 值：1.64，约 95% 服务水平。",
  hExcess: "临时默认值为 15 周，仍需业务方确认。",
  formula: "公式：覆盖周数 = 现有库存 / 最近 4 周平均实销。安全库存 = z * normalized CV * 平均周需求 * sqrt(补货交期)。ROP = 平均周需求 * 补货交期 + 安全库存。",
  kBelow: "覆盖低于目标",
  kBelowN: "低于目标的 NOOS/Semi 行",
  rowsWord: "行",
  kRop: "ROP 预警",
  kRopN: "供应量不高于 ROP",
  kExcess: "过剩 SKU",
  kExcessN: "覆盖周数超过阈值",
  kReview: "需复核",
  kReviewN: "缺 CV、未匹配等级、无实销、净退货或缺 supply parameter",
  sOverview: "概览",
  sBelow: "低于目标",
  sRop: "ROP 预警",
  sExcess: "过剩",
  sReview: "待查数据",
  oEntity: "各法人覆盖周数",
  oTier: "按等级计数",
  hdBelow: "低于目标的 NOOS 和 Semi-NOOS",
  hdRop: "再订货点预警",
  hdExcess: "处于过剩的 SKU",
  hdReview: "需检查的数据",
  colNo: "序号",
  colRows: "行数",
  colMedian: "覆盖周数中位数（周）",
  colNeedCv: "需 CV",
  colSkuProduct: "SKU / 产品",
  colOnHandPcs: "现有库存（pcs）",
  colAvgPcs: "平均实销（pcs/周）",
  colCoverageWks: "覆盖周数（周）",
  colTargetWks: "目标（周）",
  colSignal: "信号",
  colOpenPcs: "在途/未交（pcs）",
  colSupplyPcs: "供应量（pcs）",
  colRopPcs: "ROP（pcs）",
  colGapPcs: "缺口（pcs）",
  colLt: "交期（周）",
  colOver: "超出（周）",
  colIssue: "问题",
  colNote: "备注",
  sigBelow: "低于目标",
  sigReorder: "需补货",
  sigExcess: "过剩",
  isCv: "需 CV",
  noteCv: "需要 normalized CV 才能计算 ROP",
  isTier: "未匹配等级",
  noteTier: "未匹配等级 — 请在 Tier list 中添加 SAP code",
  isDead: "52 周无销售",
  noteDead: "最近 52 周无实销 - 不纳入自动补货",
  isSlow: "滞销",
  noteSlow: "52 周内有销售，但最近 4 周没有",
  isSupply: "缺 supply parameter",
  noteSupply: "无产品级 MOQ / supply parameter — 请向 Linda 确认",
  noRows: "当前假设下没有符合的行。",
  foot: "临时假设：NOOS 目标 {{a}} 周，Semi 目标 {{b}} 周，生产交期 {{c}} 周（+ 运输），NOOS z {{d}}，Semi z {{e}}，过剩阈值 {{f}} 周。",
  capped: "显示 {{n}} 行中的前 {{cap}} 行 — 请筛选缩小范围。",
  srcTitle: "数据来源",
  srcStock: "现有库存",
  srcSales: "实销截至",
  srcTransit: "未到货 PO",
  srcFile: "文件",
  srcCarry: "{{day}} 的文件（{{name}}）— 暂无更新的文件",
  srcNoStock: "当日未载入",
  srcNoSales: "52 周无销售",
  srcTransitN: "{{n}} 个品项 · {{q}} pcs",
  srcNoTransit: "未读取 — 暂无该法人的 PO 来源",
  isReturns: "净退货",
  noteReturns: "退货多于销售（52 周或最近 4 周）— 属客户退货，并非数据错误",
  srcNoneOpen: "当日无未交 PO",
  srcTransitOnly: "仅已发货：{{n}} 个品项 · {{q}} pcs（当日未读取未到货 PO）",
  srcNoteNoOp: "当日没有未到货 PO 的读取记录 — NetSuite 只能按今天读取，因此较早的日期只显示已发货部分。红色 = 早于库存日期或实销区间。",
  srcOpFailed: "（读取 NetSuite 失败：{{why}}）",
  srcNoTransitHinc: "尚未读取 — HINC 的 PO 在 SAP 中",
  srcSumStock: "库存 {{day}}",
  srcSumSales: "实销至 {{day}}",
  srcSumOp: "未到货 PO 于 {{at}} UTC 读取",
  srcSumNoOp: "当日未读取未到货 PO",
  srcSumWarn: "数据较旧：{{list}}",
  srcDetails: "详情",
  srcHide: "收起",
  srcColFrom: "来源",
  srcColCome: "待到货 (pcs)",
  srcColGroup: "其中向集团采购",
  srcColPassed: "转给集团公司",
  srcColPast: "已逾期 — 不计入",
  srcColTo: "调拨单",
  srcLines: "{{n}} 行",
  srcNoteShort: "待到货 = 尚未收货且预计到货日不早于库存日期的 PO 行；已过预计日期的行视为已发货（仅因付款未完成而未关闭）。集团公司向另一集团公司采购的数量计入买方并从卖方扣除。红色 = 早于库存日期或实销区间。",
  setWeeks: "周",
  setCardTarget: "目标覆盖周数",
  setTargetHint: "覆盖周数（现有库存 ÷ 最近 4 周平均实销）低于此值即为“低于目标”。",
  setCardZ: "服务水平系数 (z)",
  setZHint: "2.33 ≈ 99% · 1.64 ≈ 95% · 1.28 ≈ 90% 服务水平。用于计算安全库存。",
  setCardLt: "交期与过剩阈值",
  setProdLtShort: "生产交期",
  setExcessShort: "过剩阈值",
  setLtHint: "补货交期 = 生产交期 + 各法人运输周数。覆盖周数超过过剩阈值即为过剩。",
  setReadOnly: "只读 — 由管理员修改。",
  shareLink: "获取链接",
  shareTitle: "以链接分享仪表板",
  shareSub: "以 HTML 单页呈现的仪表板，始终为最新库存日期，按已保存的假设 — 无需登录门户即可打开。",
  shareWarn: "持有链接的任何人都能看到库存、实销和未到货 PO 数量（无价格）。更换链接可使旧链接失效，或直接关闭。",
  noLink: "尚无链接。",
  makeLink: "生成链接",
  replaceLink: "更换链接",
  switchOff: "关闭链接",
  copy: "复制",
  copied: "已复制",
  open: "打开",
  close: "关闭",
  setSave: "保存更改",
  setDiscard: "放弃",
  setDirty: "有未保存的更改",
  setClean: "所有数值均已保存。更改会立即应用到仪表板。",
  savedAt: "已保存 · 更改 {{n}} 个值 · {{at}}",
  setHistory: "变更记录",
  setNoHistory: "暂无记录 — 每次更改数值的保存都会列在这里。",
  histWhen: "时间（越南）",
  histWho: "修改人",
  histField: "设置项",
  histWas: "修改前",
  histNow: "修改后",
  setTransitShort: "运输周数",
};
const dictionary = { ns: 'xNoos', en, ko, vi, zh };
export default dictionary;
